import { FunctionComponent, ReactNode } from "react";
import AppContainer from "../AppContainer";
import HeaderComponent from "../HeaderComponent";
import HeaderPlaceholder from "../HeaderComponent/HeaderPlaceholder";

interface PageLayoutProps {
  children: ReactNode;
  pageId?: string;
  noHeader?: boolean;
}

const PageLayout: FunctionComponent<PageLayoutProps> = ({ children, pageId, noHeader = false }: PageLayoutProps) => {
  return (
    <>
      {!noHeader && (
        <>
          <HeaderComponent />
          <HeaderPlaceholder />
        </>
      )}

      <AppContainer id="app-container" data-name={`${pageId}-page`}>
        {children}
      </AppContainer>
    </>
  );
};

PageLayout.defaultProps = {
  pageId: "",
};

export default PageLayout;
